module.exports = __webpack_public_path__ + "assets/img/recordIcon5.66607c9d.png";